import { useMemo } from 'react';
import { FocusRightsPossibleResponse } from '@/redux/slices/focusNewScheduleSlice';

export const useRightsAvailable = (rightsPossible: FocusRightsPossibleResponse['data'] | null | undefined) => {
  return useMemo(() => {
    if (!rightsPossible) return { audio: [], timedtext: [], territories: [] };

    const audio = Array.from(
      new Set(
        Object.values(rightsPossible.territories)
          .flatMap((territory) => territory.audio)
          .map((item) => item.language)
      )
    )
      .filter((r) => r !== 'es-419')
      .sort((a, b) => a.localeCompare(b));

    const timedtext = Array.from(
      new Set(
        Object.values(rightsPossible.territories)
          .flatMap((territory) => territory.timedtext)
          .map((item) => item.language)
      )
    )
      .filter((r) => r !== 'es-419')
      .sort((a, b) => a.localeCompare(b));

    const territories = Object.keys(rightsPossible.territories)
      .sort((a, b) => a.localeCompare(b))
      .map((code) => code.toUpperCase());

    return { audio, timedtext, territories };
  }, [rightsPossible]);
};
